export const common = {
  hero: {
    badge: "الجسر التجاري الرائد في قطر",
    title1: "ربط منطقة الشرق الأوسط",
    title2: "بالعالم",
    title3: "الفرص",
    subtitle: "خدمات الوساطة التجارية الاستراتيجية من قلب الدوحة، تسهيل التجارة الدولية السلسة عبر القارات.",
    cta1: "استكشف الخدمات",
    cta2: "اتصل بفريقنا"
  },
  about: "من نحن",
  services: "الخدمات",
  regional: "التركيز الإقليمي",
  faq: "الأسئلة الشائعة",
  contact: "اتصل بنا",
  nav: {
    about: "من نحن",
    services: "الخدمات",
    regional: "التركيز الإقليمي",
    contact: "اتصل بنا",
    getStarted: "ابدأ الآن"
  }
};
